import { loc } from '../lib/_location.js';
import { getRandomItems, shuffleItems, usedCards } from '../lib/_tool.js';
import { setting } from './_setting.js';
import { startScreen } from './_start.js';
import { layout } from './_layout.js';
import { user } from './_user.js';
import { GameTimer } from './_gameTimer.js';
import { modal } from './_modal.js';
import { rankingModal } from './_rankModal.js';
import { clear } from './_clear.js';
import { operator } from './_operator.js';

const WAIT_TIME = 10950;

//const WAIT_TIME = 950;

export let memoryGame = {
	allData: [],
	data: [],//このゲームで使うデータ
	target: null,
	isStart: false,
	timer: null,
	canSelect: true,
	init: function(){
		memoryGame.target 	= document.querySelector("#c-cards");
		memoryGame.allData  = [];
		memoryGame.data 	= [];
		memoryGame.timer 	= null;
		
		operator.init();
		
		if( memoryGame.target ){
			setting.getData().then( (res) => {
				//console.log(res);
				//データ抽出
				memoryGame.allData 	= res;
				// ① 未使用データを優先して抽出
				const pool = usedCards.filterUnused(res, setting.max);
				memoryGame.data = getRandomItems(pool, setting.max);
				
				//memoryGame.data 	= getRandomItems( res, setting.max );
				//タイマー作成
				memoryGame.timer = new GameTimer();
				
				modal.init(memoryGame.data, memoryGame.timer);
				rankingModal.init();
				//レイアウト
				layout.getRatio();
				startScreen.init( getRandomItems( res, 30 ) );
				//カードを作成
				memoryGame.makeCard();
				let info = loc.all();
				let params = info.params;
				if( params.type === "replay" ){
					memoryGame.start();
				}
			});
		}
	},
	makeCard: function(){
		let HTML = "";
		let data = [];
		data = data.concat(memoryGame.data);
		data = data.concat(memoryGame.data);
		
		let cards = shuffleItems(data);
		let len = cards.length;
		for( let i = 0; i < len; i++ ){
			card = cards[i];
			//console.log(card.name, card.image)
			let img = "";
			if( card.image ){
				img = `<picture>
							<source media="(min-width: 864px)" srcset="${card.image.url}?fm=webp&w=280" width="280" height="400" decoding="async">
							<img src="${card.image.url}?fm=webp&&w=" width="128" height="182" decoding="async" alt="${card.initial}">
						</picture>`;
			}
			HTML += `<li class="card open">
						<div class="card_inner" data-id="${card.id}">
							<div class="flip">
								<div class="flip_inner">
									<div class="front">
										<div class="inr">
											<img src="/assets/images/card/img_front.webp" alt="front" width="280" height="400">
										</div>
										<p class="f_logo"><img src="/assets/images/common/logo_white.svg" alt="ASL" width="46" height="13"></p>
									</div>
									<div class="back">
										<div class="inr">
											<figure>
												${img}
											</figure>
											<p class="b_logo"><img src="/assets/images/common/logo_orange.svg" alt="ASL" width="46" height="13"></p>
											<button data-id="${card.id}">
												<img src="/assets/images/common/icon_info.svg" alt="i" width="17" height="17">
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>`;
		}
		//<p>${card.id}<br>${card.name}</p>
		document.querySelector("#c-cards ul").setAttribute("data-len", len);
		document.querySelector("#c-cards ul").innerHTML = HTML;
		layout.resize(memoryGame.isStart);
		memoryGame.navStart();
		window.addEventListener("resize", memoryGame.resize, false);
	},
	resize: function(){
		if( !memoryGame.isStart ){
			startScreen.resize();
		}
		layout.resize(memoryGame.isStart);
	},
	navStart: function(){
		let $btnStart = document.querySelectorAll("button[data-game-start]");
		const eventListenersMultiple = [
			{ elements: $btnStart, type: "click", handler: memoryGame.start }
		];
		eventListenersMultiple.forEach( ( el ) => {
			el.elements.forEach( ( element )=> {
				element.removeEventListener(el.type, el.handler, false);
				element.addEventListener(el.type, el.handler, false);
			});
		});
	},
	nav: function(){
		let $cards = document.querySelectorAll("li.card");
		const eventListenersMultiple = [
			{ elements: $cards, type: "click", handler: memoryGame.getCard }
		];
		eventListenersMultiple.forEach( ( el ) => {
			el.elements.forEach( ( element )=> {
				element.removeEventListener(el.type, el.handler, false);
				element.addEventListener(el.type, el.handler, false);
			});
		});
	},
	navGot: function(){
		let $btnInfo = document.querySelectorAll("li.card.got button[data-id]");
		const eventListenersMultiple = [
			{ elements: $btnInfo, type: "click", handler: memoryGame.selectModalId }
		];
		eventListenersMultiple.forEach( ( el ) => {
			el.elements.forEach( ( element )=> {
				element.removeEventListener(el.type, el.handler, false);
				element.addEventListener(el.type, el.handler, false);
			});
		});
	},
	start: function(){
		memoryGame.isStart = true;
		memoryGame.target.classList.add("is-start");
		
		let $lists = memoryGame.target.querySelectorAll("ul li.card");
		let count = 0;
		let max = $lists.length;
		
		let $startScreen = document.querySelector("#b-start");
		if( $startScreen.classList.contains("disable") ){ //reset済み
			if( $lists ){
				setCardPos();
			}else{
				setTimeout(function(){
					memoryGame.start();
				}, 50);
			}
			
		}else{
			$startScreen.classList.add("disable");
			$startScreen.addEventListener("transitionend", function(){
				setCardPos();
			}, {
				"once": true
			})
		}
		
		function setCardPos(){
			let $blockTime = document.querySelector(".c-time");
			let $time = document.querySelector(".c-time .js-left");
			let c = $lists[count];
			let x = c.getAttribute("data-x");
			let y = c.getAttribute("data-y");
			c.style.transform = `translate3d(${x}px, ${y}px, 0)`;
			count++;
			if( count < max ){
				setTimeout(function(){
					setCardPos();
				}, Math.random()*30 + 50);
			}else{
				let startTime = 0;
				let memoryTime = WAIT_TIME;
				setTimeout(function(){
					startTime = getNow();
					//10秒以内にカードを記憶してください
					operator.change("selectCard", 3500);
					setTimeout(function(){
						startTime = getNow();
						countDown();
					}, 3500);
				}, 1000);
				function countDown(){
					let diff = getNow() - startTime;
					//console.log(diff);
					if( diff >= WAIT_TIME ){
						if( $blockTime.classList.contains("is-countdown") ){
							$blockTime.classList.remove("is-countdown");
						}
						$lists.forEach( ($list, index) =>{
							$list.classList.remove("open");
						});
						setTimeout(function(){
							//同じカードを選んでください。お手つきは5秒のペナルティです。
							operator.change("gameDescription", 3500);
							setTimeout(function(){
								operator.change("start", 2000);
								setTimeout(function(){
									memoryGame.timer.start();
									memoryGame.nav();
								}, 2000);
							}, 4500 );
						}, 1000);
						
					}else{
						addTime(diff);
						setTimeout(function(){
							countDown();
						}, 100);
					}
				}
				function addTime( diff ){
					if( !$blockTime.classList.contains("is-countdown") ){
						$blockTime.classList.add("is-countdown");
					}
					const total = Math.floor( (WAIT_TIME - diff) / 1000);
					const min = String(Math.floor(total / 60)).padStart(2, "0");
					const sec = String(total % 60).padStart(2, "0");
					$time.innerHTML = `${sec}`;
				}
			}
		}
	},
	getCard: function(e){
		if( memoryGame.canSelect ){
			memoryGame.canSelect = false;
			let $target = e.currentTarget;
			let id = $target.querySelector(".card_inner").getAttribute("data-id");
			//.gotがついているものはモーダルで開ける
			if( $target.classList.contains("got") ){
				//modal.selectData( id, memoryGame.data );
				memoryGame.canSelect = true;
			}else if( $target.classList.contains("select") ){
				memoryGame.canSelect = true;
				return false
			}else{
				user.currentSelect.push(id);
				$target.classList.add("select");
				
				user.checkCard( memoryGame.timer ).then( (res) => {
					//console.log(`%c${res}` , 'color: white; background-color: #176681;');
					let progress = user.got.length / setting.max * 100;
					//document.querySelector("#debug .got").innerHTML = user.got.length;
					//document.querySelector("#debug .max").innerHTML = setting.max;
					//document.querySelector("#debug .progress").innerHTML = progress + "%";
					//console.log(user.got.length);
					//console.log(res);
					memoryGame.navGot();
					//console.log( "クリア回数:", clear.getPlayCount() );
					if( res === "success" && user.got.length === 1){
						if( clear.getPlayCount() === 0 ){
							//正解したカードを選ぶとASL社員について知ることができます。
							operator.change("modal", 3000);
							modal.selectData( id, memoryGame.data );
						}
					}
					//ゲーム終了
					if( progress === 100 || user.got.length === setting.max){
						//console.log("ゲームクリア");
						user.isClear = true;
						memoryGame.timer.pause();
						memoryGame.canSelect = true;
						operator.change("end", 3000);
						setTimeout(function(){
							clear.init(memoryGame, user);
							const usedIds = memoryGame.data.map(d => d.id);
							usedCards.save(usedIds);
						}, 5000);
					}else{
						memoryGame.canSelect = true;
					}
				});
			}
		}
	},
	selectModalId: function(e){
		let $target = e.currentTarget;
		let id = $target.getAttribute("data-id");
		modal.selectData( id, memoryGame.data );
	},
	reset: function(){
		//console.log(`%cemoryGame reset` , 'color: white; background-color: #176681;');
		user.miss 		= 0;
		user.isClear 	= false;
		user.name 		= "";
		user.currentSelect = [];
		user.got = [];
		document.querySelector("#c-cards ul").innerHTML = "";
		document.querySelector(".type_game .c-time").classList.add("is-countdown");
		document.querySelector(".js-left").innerHTML = "10";
		document.querySelector(".c-miss dd span").innerHTML = "00";
		memoryGame.isStart = false;
		modal.closeModal();
		memoryGame.init();
		setTimeout(function(){
			memoryGame.start();
		}, 300);
	}
}
let getNow = ()=> {
	let n = new Date();
	return n.getTime();
}